import { Component, OnDestroy, OnInit } from '@angular/core';
declare var MediaRecorder: any;

@Component({
  selector: 'app-product-voice-search',
  templateUrl: './product-voice-search.component.html',
  styleUrls: ['./product-voice-search.component.scss']
})
export class ProductVoiceSearchComponent implements OnDestroy {

  // private http = inject(HttpClient);

  // --- UI state
  isListening = false;
  hint = 'Maintenez le bouton pour parler…';
  query = '';
  results: any[] = [];
  errorMsg = '';

  // --- MediaRecorder
  private stream?: MediaStream;
  private recorder?: any;
  private chunks: Blob[] = [];

  // --- ENDPOINTS (adaptez les URLs si besoin)
  private STT_URL = '/api/stt:transcribe';  // backend -> Google STT
  private SEARCH_URL = '/api/products';     // votre API produits

  async startRecording() {
    this.errorMsg = '';
    if (this.isListening) return;

    try {
      // 1) Demande micro (HTTPS requis)
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // 2) On choisit un format supporté par Google STT (opus)
      const mime = this.getSupportedMime([
        'audio/webm;codecs=opus',
        'audio/ogg;codecs=opus',
        'audio/webm',
        'audio/ogg'
      ]);
      if (!mime) {
        this.errorMsg = 'Format audio non supporté par ce navigateur.';
        return;
      }

      this.recorder = new MediaRecorder(this.stream, { mimeType: mime });
      this.chunks = [];
      this.recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) this.chunks.push(e.data);
      };
      this.recorder.onstart = () => {
        this.isListening = true;
        this.hint = 'Enregistrement… relâchez pour envoyer';
      };
      this.recorder.onstop = () => {
        this.isListening = false;
        this.hint = 'Transcription en cours…';
        this.stopStream();

        const blob = new Blob(this.chunks, { type: mime });
        this.sendToStt(blob);
      };

      this.recorder.start();
    } catch (err) {
      this.errorMsg = 'Accès au micro refusé ou indisponible.';
      this.stopStream();
    }
  }

  stopRecording() {
    if (this.recorder && this.recorder.state !== 'inactive') {
      this.recorder.stop();
    } else {
      this.stopStream();
    }
  }

  private stopStream() {
    if (this.stream) {
      this.stream.getTracks().forEach((t) => t.stop());
      this.stream = undefined;
    }
  }

  private getSupportedMime(candidates: string[]) {
    for (const c of candidates) {
      if (MediaRecorder.isTypeSupported(c)) return c;
    }
    return '';
  }

  private sendToStt(blob: Blob) {
    // Envoi multipart pour éviter le base64 côté front
    const form = new FormData();
    form.append('audio', blob, `recording.${blob.type.includes('ogg') ? 'ogg' : 'webm'}`);

    console.log('SEND TO API: ', blob);
    
    // this.http.post<{ transcript: string }>(this.STT_URL, form).subscribe({
    //   next: (res) => {
    //     this.query = res.transcript?.trim() ?? '';
    //     this.hint = this.query ? `“${this.query}”` : 'Aucun texte détecté';
    //     if (this.query) this.searchProducts(this.query);
    //   },
    //   error: (e) => {
    //     this.errorMsg = 'Échec de la transcription.';
    //     this.hint = 'Réessayez';
    //   }
    // });
  }

  private searchProducts(q: string) {
    // this.http.get<any[]>(this.SEARCH_URL, { params: { q } })
    //   .subscribe({
    //     next: (res) => (this.results = res),
    //     error: () => (this.errorMsg = 'Erreur lors de la recherche produits.')
    //   });
  }

  ngOnDestroy(): void {
    this.stopStream();
    if (this.recorder && this.recorder.state !== 'inactive') {
      this.recorder.stop();
    }
  }

}
